import { render, staticRenderFns } from "./customizer.vue?vue&type=template&id=c10205fa&"
import script from "./customizer.vue?vue&type=script&lang=js&"
export * from "./customizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports